/*
 * Project: bellcloud
 * File: packages/protocol/lite/fn_file_transfer.ts
 * Author: SWAN
 * Created: 2025-07-21 16:52:52
 * Description:ClassID.FILE_TRANSFER (0x10)에 대한 FunctionID별 파라미터 정의
 */
import type { FunctionParameter } from '../fns';

export const params_file_transfer: Record<number, FunctionParameter[]> = {
  0x01: [
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '0:Gas, 1:Event, 2:GenConf, 3:SenConf, 4:GasAlarm, 5:Cal/Bump',
      format: 'enum_file_type',
    },
    {
      name: 'days_of_gas_reading',
      type: 'u8',
      bytes: 1,
      comment: 'Days (8h/day, 15s interval)',
      format: 'number',
    },
    {
      name: 'transfer_mode',
      type: 'u8',
      bytes: 1,
      comment: '0: Normal, 1: Burst',
      format: 'enum_transfer_mode',
    },
  ],
  0x02: [
    { name: 'file_type', type: 'u16', bytes: 2, comment: 'file type', format: 'enum_file_type' },
    { name: 'version', type: 'u16', bytes: 2, comment: 'Structure version', format: 'version' },
    { name: 'chunk_size', type: 'u16', bytes: 2, comment: 'MTU size', format: 'number' },
    { name: 'num_packets', type: 'u16', bytes: 2, comment: 'Number of packets', format: 'number' },
    { name: 'total_size', type: 'u32', bytes: 4, comment: 'Total size of file', format: 'number' },
  ],
  0x03: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Data log chunk index',
      format: 'number',
    },
  ],
  0x04: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Returned chunk index',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 2048,
      comment: 'Binary data chunk (max 2048B, compressed for FW >= 5.0.0)',
      format: 'binary',
    },
  ],
  0x05: [
    { name: 'chunk_index', type: 'u16', bytes: 2, comment: 'Event chunk index', format: 'number' },
  ],
  0x06: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Returned event index',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 512,
      comment: 'Binary event data',
      format: 'binary',
    },
  ],
  0x07: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Gen config chunk index',
      format: 'number',
    },
  ],
  0x08: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Returned gen config index',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 512,
      comment: 'Binary config data',
      format: 'binary',
    },
  ],
  0x09: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Sensor config chunk index',
      format: 'number',
    },
  ],
  0x0a: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Returned sensor config index',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 512,
      comment: 'Binary config data',
      format: 'binary',
    },
  ],
  0x0b: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Alarm log chunk index',
      format: 'number',
    },
  ],
  0x0c: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Returned alarm log chunk',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 512,
      comment: 'Alarm log binary data',
      format: 'binary',
    },
  ],
  0x0d: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Cal/Bump log chunk index',
      format: 'number',
    },
  ],
  0x0e: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Returned Cal/Bump log chunk',
      format: 'number',
    },
    {
      name: 'chunk_data',
      type: 'au8[]',
      bytes: 512,
      comment: 'Cal/Bump binary data',
      format: 'binary',
    },
  ],
  0x10: [
    { name: 'header_crc', type: 'u16', bytes: 2, comment: 'CRC of header', format: 'number' },
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '0:FW, 1:Sensor, 2:Settings',
      format: 'enum_sensor_data_type',
    },
    {
      name: 'version',
      type: 'au8[]',
      bytes: 3,
      comment: 'Version (major/minor/patch)',
      format: 'version',
    },
    { name: 'file_crc', type: 'u16', bytes: 2, comment: 'CRC of file', format: 'number' },
    { name: 'chunk_size', type: 'u16', bytes: 2, comment: 'Chunk size (MTU)', format: 'number' },
    { name: 'num_packets', type: 'u16', bytes: 2, comment: 'Number of packets', format: 'number' },
    { name: 'total_size', type: 'u32', bytes: 4, comment: 'Total size of file', format: 'number' },
  ],
  0x11: [
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '[0]: Firmware, [1]: Sensor data, [2]: Settings, [3], EEPROM',
      format: 'enum_sensor_data_type',
    },
  ],
  0x12: [
    { name: 'chunk_index', type: 'u16', bytes: 2, comment: 'Chunk index', format: 'number' },
    { name: 'chunk_data', type: 'au8[]', bytes: 512, comment: 'Chunk data', format: 'binary' },
  ],
  0x13: [
    {
      name: 'chunk_index',
      type: 'u16',
      bytes: 2,
      comment: 'Acknowledged chunk index',
      format: 'number',
    },
  ],
  0x14: [
    {
      name: 'file_type',
      type: 'u8',
      bytes: 1,
      comment: '0:Firmware, 1:Sensor, 2:Settings',
      format: 'enum_sensor_data_type',
    },
    { name: 'version', type: 'au8[]', bytes: 3, comment: 'Structure version', format: 'version' },
  ],
  0x15: [
    { name: 'result', type: 'u8', bytes: 1, comment: '0:Fail, 1:Start update', format: 'bool' },
  ],
  0x17: [{ name: 'result', type: 'u8', bytes: 1, comment: '0:Fail, 1:Stopped', format: 'bool' }],
  0x18: [
    { name: 'datalog chunk index', type: 'u16', bytes: 2, comment: 'datalog chunk index' },
    {
      name: 'datalog chunk(binary)',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
    },
  ],
  0x19: [
    { name: 'datalog chunk index', type: 'u16', bytes: 2, comment: 'datalog chunk index' },
    {
      name: 'datalog chunk(binary)',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
    },
  ],
  0x1a: [
    { name: 'chunk_index', type: 'u16', bytes: 2, comment: 'Chunk index for file transfer' },
    { name: 'chunk_data', type: 'au8[]', bytes: 512, comment: 'Max Payload size - other data' },
  ],
  0x1b: [
    { name: 'chunk_index', type: 'u16', bytes: 2, comment: 'Chunk index for file transfer' },
    { name: 'chunk_data', type: 'au8[]', bytes: 512, comment: 'Max Payload size - other data' },
  ],
  0x1c: [
    { name: 'chunk_index', type: 'u16', bytes: 2, comment: 'cal/bump chunk index' },
    { name: 'chunk_data', type: 'au8[]', bytes: 512, comment: 'Max Payload size - other data' },
  ],
  0x1d: [
    { name: 'cal/bump chunk index', type: 'u16', bytes: 2, comment: 'cal/bump chunk index' },
    {
      name: 'cal/bump chunk(binary)',
      type: 'au8[]',
      bytes: 512,
      comment: 'Max Payload size - other data',
    },
  ],
};
